// extracted by mini-css-extract-plugin
export default {"tags":"tags_2ga9","tag":"tag_11ep"};